import request from '@/utils/request'
import qs from 'qs'

// 套餐列表
export function Packages(query) {
  return request({
    url: '/bolan/package/',
    method: 'get',
    params: query
  })
}

// 创建订单
export function createOrder(data) {
  return request({
    url: '/bolan/order/',
    method: 'post',
    data: data,
  })
}

// 我的订单列表
export function orderList(query) {
  return request({
    url: '/bolan/order/',
    method: 'get',
    params: query
  })
}

// 订单详情
export function orderDetail(query) {
  return request({
    url: '/bolan/order/',
    method: 'get',
    params: query
  })
}

// 确认已完成转账（银行转账支付版）
export function confirmTransfer(data) {
  return request({
    url: '/bolan/order/',
    method: 'post',
    data: qs.stringify(data),
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
    }
  })
}

// 在线支付（支付宝/微信扫码）
export function payOrder(data) {
  return request({
    url: '/bolan/pay/',
    method: 'post',
    data: data,
  })
}

// 查询支付状态
export function payStatus(query) {
  return request({
    url: '/bolan/pay/',
    method: 'get',
    params: query
  })
}

// 站内消息列表
export function messageList(query) {
  return request({
    url: '/bolan/message/',
    method: 'get',
    params: query
  })
}

// 标记消息已读
export function messageRead(data) {
  return request({
    url: '/bolan/message/',
    method: 'post',
    data: qs.stringify(data),
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
    }
  })
}

// 电子合同
export function getContract(query) {
  return request({
    url: '/bolan/contract/',
    method: 'get',
    params: query
  })
}



// WEBPACK FOOTER //
// ./src/api/order.js